import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
    WebsiteAlertServiceProxy,
    IWebsiteAlertDto,
    WebsiteAlertDtoPagedResultDto
} from '@shared/service-proxies/service-proxies';
import { WINDOW } from '@app/shared/common/services/window.service';

const watchedKey = 'maintenanceNoticesWatched';

@Injectable()
export class MaintenanceNoticesService {

    private _isHidden = true;

    private activeMaintenanceNotices$: Observable<IWebsiteAlertDto[]>;
    private alerts: IWebsiteAlertDto[];

    constructor(
        private api: WebsiteAlertServiceProxy,
        @Inject(WINDOW) private window: Window
    ) {
        this.getActive$.subscribe(this.setIsHidden.bind(this));
    }

    get getActive$(): Observable<IWebsiteAlertDto[]> {
        const previouslyWatched: number[] = this.getPreviouslyWatched();

        return this.activeMaintenanceNotices$ ||
            (this.activeMaintenanceNotices$ =
                this.api.getActive()
                    .pipe(map(alerts => alerts.filter(alert => previouslyWatched.indexOf(alert.id) === -1)))
            );
    }

    get isHidden(): boolean {
        return this._isHidden;
    }

    getAll$(sorting: string | null | undefined, maxResultCount: number, skipCount: number): Observable<WebsiteAlertDtoPagedResultDto> {
        return this.api.getAll(
            sorting,
            maxResultCount,
            skipCount);
    }

    hide() {
        this.window.localStorage.setItem(
            watchedKey,
            JSON.stringify(this.getPreviouslyWatched().concat(this.getNotWatched()))
        );
        this._isHidden = true;
    }

    private setIsHidden(alerts: IWebsiteAlertDto[]) {
        this.alerts = alerts;
        this._isHidden = this.getNotWatched().length === 0;
    }

    private getPreviouslyWatched(): number[] {
        const previouslyWatched: string = this.window.localStorage.getItem(watchedKey);
        return previouslyWatched ? JSON.parse(previouslyWatched) : [];
    }

    private getNotWatched(): number[] {
        const previouslyWatched: number[] = this.getPreviouslyWatched();

        return this.alerts
            .map(notice => notice.id)
            .filter(id => previouslyWatched.indexOf(id) === -1);
    }
}
